declare let RR;
declare let dataLayer;

interface Window {
    recommendationHelper?: (util, recommendationHelper) => void;
}

window.recommendationHelper = (util, personalizationHelper): object => {
    "use strict";
    let isPersonalizationEnabled = false;
    if (typeof personalizationHelper !== "undefined") {
        isPersonalizationEnabled = true;
    }
    const numberOfRecommendation = 4;
    function check_webp_feature(feature, callback) {
        const kTestImages = {
            lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
            lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
            alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
            animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
        };
        let img = new Image();
        img.onload = function () {
            var result = (img.width > 0) && (img.height > 0);
            callback(feature, result);
        };
        img.onerror = function () {
            callback(feature, false);
        };
        img.src = "data:image/webp;base64," + kTestImages[feature];
    }

    var isWebpSupported = false;
    check_webp_feature('lossy', function (feature, isSupported) {
        if (isSupported) {
            isWebpSupported = true;
        }
    });

    return {
        sendTrackingData(index, data, gaEvent): void {
            dataLayer.push(
                {
                    event: "CustomEventTracking",
                    eventCategory: `Cross Sell ${gaEvent}`,
                    eventAction: "Recommended",
                    eventLabel: data.productTypeCategory + " - " + data.title + " - " + data.itemId,
                    eventValue: index
                });
        },

        createRecommendationTile(index, template, data, gaEvent, recommendationPlaceholders): string {
            const productData = data.itemId.split("_");
            data.productCode = productData ? productData[0] : "";
            data.designCode = productData ? productData[1] : "";
            let imageUrl = isWebpSupported ? data.imageUrl : data.imageUrl.replace(new RegExp(".webp", "ig"), ".jpg");
            imageUrl = isPersonalizationEnabled ? personalizationHelper.personalizedImageUrl(imageUrl) : imageUrl;
            return template
                .replace(new RegExp(recommendationPlaceholders.DesignCode, "g"), data.designCode)
                .replace(new RegExp(recommendationPlaceholders.ProductCode, "g"), data.productCode)
                .replace(new RegExp(recommendationPlaceholders.LinkUrl, "g"), data.linkUrl)
                .replace(new RegExp(recommendationPlaceholders.ImageUrl, "g"), imageUrl)
                .replace(new RegExp(recommendationPlaceholders.Title, "g"), data.title)
                .replace(new RegExp(recommendationPlaceholders.Price, "g"), data.price)
                .replace(new RegExp(recommendationPlaceholders.ProductTypeCategory, "g"), data.productTypeCategory)
                .replace(new RegExp(recommendationPlaceholders.RecommendationType, "g"), "AI")
                .replace(new RegExp(recommendationPlaceholders.Position, "g"), index.toString())
                .replace(new RegExp(recommendationPlaceholders.GAEventCategory, "g"), `Cross Sell ${gaEvent}`)
                .replace(new RegExp(recommendationPlaceholders.ItemId, "g"), data.itemId);
        },

        async addRecommendationTile(showLivePricing, selectedRecommendation, id, gaEvent, placeholders): Promise<void> {
            const recommendationPlacement = "recommendation-placement-" + id;
            const tiles = document.getElementById(recommendationPlacement);
            const tileContent = tiles.innerHTML;
            tiles.innerHTML = "";
            const totalNumberOfRecommendation = numberOfRecommendation;

            for (let i = 0; i < selectedRecommendation.items.length; i++) {
                if (i < totalNumberOfRecommendation) {
                    const recommendation = selectedRecommendation.items[i];
                    this.sendTrackingData(i + 1, recommendation, gaEvent);

                    if (showLivePricing) {
                        const productKey = this.getProductKeyFromRecommendationLinkUrl(recommendation.linkUrl);
                        const priceModelUrl = "/services/printing/api/v3/product/" + productKey + "/pricemodel";
                        const result = await util.ajax("GET", priceModelUrl);
                        const priceModel = JSON.parse(result);
                        recommendation.price = this.getRecommendationPriceTextFromPriceModel(priceModel.Prices);
                    }
                    tiles.innerHTML += this.createRecommendationTile(i + 1, tileContent, recommendation, gaEvent, placeholders);
                }
            }
        },

        getRecommendationPriceTextFromPriceModel: function (priceModel) {
            var priceModelSorted = priceModel.slice(0);
            priceModelSorted.sort((a, b) => a.MinQuantity - b.MinQuantity);
            var startingPrice = priceModelSorted[0];
            var minQuantity = startingPrice.MinQuantity;
            var minPrice = startingPrice.MinQuantity * startingPrice.Price;
            return "Starting at $" + minPrice.toFixed(2) + " for " + minQuantity;
        },

        getProductKeyFromRecommendationLinkUrl: function (url) {
            var productUri = encodeURIComponent("/services/printing/product/");
            var productKeyIndex = url.indexOf(productUri) + productUri.length;
            return (url.substring(productKeyIndex));
        },

        hideRecommendationPlacement(id): void {
            document.getElementById(`recommendation-div-${id}`).classList.add("hide");
            document.getElementById(`recommendation-div-${id}`)
                .setAttribute("automation-recommendation-source", "No Recommendation");
        },

        async showRecommendation(showLivePricing, placementId, placementName, gaEvent, recommendationPlaceholders): Promise<void> {
            const recommendationPlacementDiv = `recommendation-div-${placementId}`;
            const placement = document.getElementById(recommendationPlacementDiv);

            if (placement !== undefined) {
                placement.classList.remove("hide");
                const recommendationData = (typeof (RR) !== "undefined" && RR && RR.data && RR.data.JSON) ? RR.data.JSON.placements : null;
                if (recommendationData) {
                    const selectedRecommendation = recommendationData.filter(function (obj) {
                        return obj.placement_name === placementName;
                    })[0];
                    if (selectedRecommendation === undefined) {
                        this.hideRecommendationPlacement(placementId);
                    } else {
                        const dynamicTitle = selectedRecommendation.message ? selectedRecommendation.message : null;
                        if (dynamicTitle) {
                            const titleElement = document.getElementById(`recommendation-title-${placementId}`);
                            titleElement.innerHTML = dynamicTitle;
                        }

                        try {
                            await this.addRecommendationTile(showLivePricing, selectedRecommendation, placementId, gaEvent, recommendationPlaceholders);
                        } catch (err) {
                            // Hide the placement if any of the recommendation tiles failed
                            this.hideRecommendationPlacement(placementId);
                        }
                    }
                } else {
                    this.hideRecommendationPlacement(placementId);
                }
            }
            const spinner = document.getElementById("recommendation-spinner-" + placementId);
            spinner.classList.add("hide");
        }
    };
};
